import { render, staticRenderFns } from "./ModalChecklistPendingCertificates.vue?vue&type=template&id=f044e254&scoped=true"
import script from "./ModalChecklistPendingCertificates.vue?vue&type=script&lang=js"
export * from "./ModalChecklistPendingCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f044e254",
  null
  
)

export default component.exports